function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import styled from 'styled-components';
import { finectAPI } from '@finect/front-utils/finectAPI';
var Image = styled.img.withConfig({
  displayName: "ImageBlock__Image",
  componentId: "sc-sa2a2d-0"
})(["display:block;opacity:", ";max-width:100%;height:auto;margin:0 auto;transition:opacity 0.15s ease;"], function (_ref) {
  var loading = _ref.loading;
  return loading ? 0.3 : 1;
});
export var ImageBlock = function (_React$Component) {
  _inherits(ImageBlock, _React$Component);
  var _super = _createSuper(ImageBlock);
  function ImageBlock() {
    var _this;
    _classCallCheck(this, ImageBlock);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      loading: _this.isBlob()
    });
    return _this;
  }
  _createClass(ImageBlock, [{
    key: "getData",
    value: function getData() {
      var _this$props = this.props,
        contentState = _this$props.contentState,
        block = _this$props.block;
      return contentState.getEntity(block.getEntityAt(0)).getData();
    }
  }, {
    key: "isBlob",
    value: function isBlob() {
      var _this$getData = this.getData(),
        src = _this$getData.src;
      return src.includes('blob');
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var block = this.props.block;
      var entityKey = block.getEntityAt(0);
      var _this$getData2 = this.getData(),
        file = _this$getData2.file,
        name = _this$getData2.name,
        updateImage = _this$getData2.updateImage;
      if (!this.isBlob()) return this.setState({
        loading: false
      });
      var formData = new FormData();
      formData.append('upfile', file);
      if (!(file instanceof File)) {
        return;
      }
      finectAPI({
        version: 'v4',
        path: 'resources/media/images',
        method: 'POST',
        body: formData,
        onSuccess: function onSuccess(_ref2) {
          var data = _ref2.data;
          var path = data.path;
          _this2.setState({
            loading: false
          });
          updateImage(entityKey, {
            name: name,
            src: path
          });
        },
        onError: function onError(error) {
          var status = error.status;
          if ([400].includes(status)) {
            updateImage(entityKey, {
              name: name,
              src: ''
            });
          }
          alert('La imagen no es válida. Debe ser de al menos 728x485 píxels.');
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getData3 = this.getData(),
        src = _this$getData3.src,
        name = _this$getData3.name;
      if (!src) {
        return null;
      }
      return React.createElement(Image, {
        loading: this.state.loading,
        src: src,
        alt: name
      });
    }
  }]);
  return ImageBlock;
}(React.Component);